import React from "react";
import ReactDOM from "react-dom";

import OnlineAssetList from "./components/online-asset-list";

const oarList = document.getElementById("oar-list");

const assetId = oarList.getAttribute("assetId");
const assetType = oarList.getAttribute("assetType");

ReactDOM.render(
  <OnlineAssetList assetId={assetId} assetType={assetType} />,
  oarList,
);
